import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-thanks',
  templateUrl: './thanks.component.html',
  styleUrls: ['./thanks.component.scss']
})
export class ThanksComponent implements OnInit {

  registerSuccess: false;
  encrypted_ChipId: string;
  petTitle: string;
  type: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params['registerSuccess']) {               
        this.registerSuccess = params['registerSuccess'];
        this.encrypted_ChipId = params['encryptedpetChipId'];
        this.petTitle = params['petTitle'];
        this.type = parseInt(params['petType']) == 1 ? 'lost' : 'found';                
      }
    });
  }

  goToPetDetail() {    
    this.router.navigate([`savnetfunnet/${this.type}/${this.encrypted_ChipId}/${this.petTitle}`]);
  }
}

